import axios from 'axios';

export const state = {
    currentUser: localStorage.getItem('currentUser'),
    token: localStorage.getItem('authToken'),
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('currentUser', newValue)
    }
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        console.log('current user', state.currentUser);
        return state.currentUser
    },
    hasLoggedIn(state){
        return state.currentUser !== null
    },
    isAdmin(state){
        return state.currentUser.role_id === 2
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    // Logs out the current user.
    logOut({ commit }) {
        // eslint-disable-next-line no-unused-vars
        commit('SET_CURRENT_USER', null)
        localStorage.removeItem('authToken')
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    async validate({ commit, state }) {
        let token = await localStorage.getItem('authToken')
        console.log('token', token)

        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API + '/profile', {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                const user = response.data.data
                
                commit('SET_CURRENT_USER', user)
                resolve(true)
            })
            .catch((error) => {
                resolve(false)
            });
        });
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    localStorage.setItem(key, JSON.stringify(state))
}
